export const adaptEvent = (data: IEvent): MeeEvent => {
	return {
		id: data.id,
		name: data.name,
		location: data.location,
		body: data.body,
		startDate: data.start_date,
		showStartDate: data.show_start_date,
		endDate: data.end_date,
		showEndDate: data.show_end_date,
		tag: data.tag,
		published: data.published,
		image: data.image,
		createdBy: data.created_by
			? {
					id: data.created_by.id,
					firstName: data.created_by.first_name,
					lastName: data.created_by.last_name
				}
			: undefined,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptEvents = (data: IEvent[]): MeeEvent[] => {
	return data.map(adaptEvent);
};
